
<template>
  <div id="app">
    <headerView></headerView>
    <router-view />
    <footerView></footerView>
  </div>
</template>

<script>
import headerView from '@components/header'
import footerView from '@components/footer'
export default {
  name: 'appName',
  components: { headerView, footerView },
  data() {
    return {}
  },
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>



<style lang='scss' scope>

</style>